export function normalizeCui(cui: string | undefined | null): string {
  if (!cui) return "";
  return cui.trim().toUpperCase().replace(/^RO/i, "");
}
